module.exports = __webpack_public_path__ + "img/sholom-benzev-wins-carr-challenge-snap-quiz.e65f8fbf.jpg";